import React, { Component, useEffect, useState } from 'react'
import { NavDropdownMenu } from "react-bootstrap-submenu";
import { NavDropdown } from 'react-bootstrap';
import { useHistory, withRouter, useParams } from 'react-router-dom';
function ContentMenu(props) {
    const history = useHistory();
    const { userId } = useParams();
    const { bookVO, chapterList } = props;
    useEffect(() => { let chlst = chapterList }, []);
    const handleChapterSelection = (e) => {
        var chapterId = e.currentTarget.getAttribute("chapterId")
        if (chapterId !== null) {
            history.push(`/read/users/${userId}/books/${bookVO.bookISBN}/${chapterId}`);
        }
    }
    return (
        <NavDropdownMenu title="Contents" id="collasible-nav-dropdown">
            <div className="navBarScrollBlock">
                {
                    chapterList !== undefined ? chapterList.map((cList, index) => {
                        return (
                            <NavDropdown.Item key={index} href="#" chapterId={cList.chapterId} onClick={handleChapterSelection}>
                                {cList.navbarTitle}
                            </NavDropdown.Item>
                        )
                    }) : ""
                }
            </div>
        </NavDropdownMenu>
    )
}
export default withRouter(ContentMenu)